import { Component } from '@angular/core';
import { TableColmuns } from 'src/app/interface/TableColumnsinterface';

@Component({
  selector: 'app-dialog-clasificacion',
  templateUrl: './dialog-clasificacion.component.html',
  styleUrl: './dialog-clasificacion.component.scss'
})
export class DialogClasificacionComponent {

  public opedata: any;

  
  tableColumns : TableColmuns []=[
    {id: 'contador', name:'#', isShow: false, isDate: false, isNumber: false, isString: true},
    {id: 'isooper', name:'ID', isShow: false, isDate: false, isNumber: false, isString: true},
    {id: 'nombreCompania', name:'Nombre', isShow: true, isDate: false, isNumber: false, isString: true},
    {id: 'fechaOperacion', name:'Fecha', isShow: true, isDate: true, isNumber: false, isString: false},
    {id: 'tipoOperacion', name:'Tipo', isShow: true, isDate: false, isNumber: false, isString: true},
    {id: 'precioentradareal', name:'Precio Entrada', isShow: true, isDate: false, isNumber: true, isString: false},


   ]

   displayedColumns: string[] = ['nombreCompania', 'fechaOperacion',
                                'tipoOperacion','precioentradareal'];
  filaSeleccionada: any;

  selectRow(row: any){
    this.filaSeleccionada=row;

  }

}
